var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 8.33334C9.34091 8.33334 10.8333 6.84095 10.8333 5C10.8333 3.15906 9.34091 1.66667 7.49996 1.66667C5.65901 1.66667 4.16663 3.15906 4.16663 5C4.16663 6.84095 5.65901 8.33334 7.49996 8.33334Z",
    stroke: "#240B3B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5C13.163 7.5 13.7989 7.23661 14.2678 6.76777C14.7366 6.29893 15 5.66304 15 5C15 4.33696 14.7366 3.70107 14.2678 3.23223C13.7989 2.76339 13.163 2.5 12.5 2.5",
    stroke: "#240B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 17.5C10.7216 17.5 13.3333 16.0076 13.3333 14.1667C13.3333 12.3257 10.7216 10.8333 7.49996 10.8333C4.2783 10.8333 1.66663 12.3257 1.66663 14.1667C1.66663 16.0076 4.2783 17.5 7.49996 17.5Z",
    stroke: "#240B3B",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.6667C16.4617 11.9875 17.5 12.7992 17.5 13.75C17.5 14.6083 16.655 15.3525 15.4167 15.725",
    stroke: "#240B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGroup);
export default __webpack_public_path__ + "static/media/users-group.33ae9fe7814c4a8cbe3b3232a4e90224.svg";
export { ForwardRef as ReactComponent };